(function () {
  'use strict';

  var ACCORDION_FALLBACK_MS = 550;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function clearDisclosureTimer(panel) {
    if (!panel) return;
    if (panel._disclosureTimer) {
      window.clearTimeout(panel._disclosureTimer);
      panel._disclosureTimer = null;
    }
    if (panel._disclosureHandler) {
      panel.removeEventListener('transitionend', panel._disclosureHandler);
      panel._disclosureHandler = null;
    }
  }

  function setDisclosure(panel, open, instant) {
    if (!panel) return;
    clearDisclosureTimer(panel);
    instant = instant || prefersReducedMotion();

    if (open) {
      panel.hidden = false;
      if (instant) {
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      void panel.offsetHeight;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      return;
    }

    panel.classList.remove('is-open');
    if (instant || panel.hidden) {
      panel.hidden = true;
      return;
    }

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows') {
        return;
      }
      clearDisclosureTimer(panel);
      panel.hidden = true;
    }

    panel._disclosureHandler = finish;
    panel.addEventListener('transitionend', finish);
    panel._disclosureTimer = window.setTimeout(finish, ACCORDION_FALLBACK_MS);
  }

  function allSections() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-acordeon]'));
  }

  function navEntries() {
    return allSections()
      .map(function (section) {
        return {
          section: section,
          title: (section.getAttribute('data-acordeon-title') || '').trim(),
          id: section.id
        };
      })
      .filter(function (entry) {
        return entry.title !== '';
      });
  }

  function slotFor(section) {
    if (!section) return null;
    return document.querySelector('[data-acordeon-slot][data-acordeon-for="' + section.id + '"]');
  }

  function currentSection() {
    return document.querySelector('[data-acordeon].is-current') || allSections()[0] || null;
  }

  function closeMenus() {
    document.querySelectorAll('[data-acordeon-menu-toggle]').forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      setDisclosure(panel, false);
    });
  }

  function createNavItem(entry, options) {
    var isCurrent = options.currentSection === entry.section;
    if (options.hideCurrent && isCurrent) return null;

    var node = document.createElement(isCurrent || !entry.id ? 'span' : 'a');
    node.className = 'acordeon__nav-item body-3' + (isCurrent ? ' is-current' : '');
    if (!isCurrent && entry.id) {
      node.href = '#' + entry.id;
      node.addEventListener('click', function (event) {
        event.preventDefault();
        showInstance(entry.section);
      });
    }
    if (isCurrent) {
      node.setAttribute('aria-current', 'page');
    }

    if (isCurrent && options.iconSource && options.iconSource.content) {
      var icon = document.createElement('span');
      icon.className = 'acordeon__nav-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.appendChild(options.iconSource.content.cloneNode(true));
      node.appendChild(icon);
    }

    var label = document.createElement('span');
    label.className = 'acordeon__nav-label';
    label.textContent = entry.title;
    node.appendChild(label);
    return node;
  }

  function fillNav(nav, entries, section, iconSource, hideCurrent) {
    if (!nav) return;
    nav.innerHTML = '';
    entries.forEach(function (entry) {
      var node = createNavItem(entry, {
        currentSection: section,
        iconSource: iconSource,
        hideCurrent: hideCurrent
      });
      if (node) nav.appendChild(node);
    });
  }

  function collectSlots() {
    var sections = allSections();
    var host = sections[0];
    if (!host) return;

    var stage = host.querySelector('[data-acordeon-stage]');
    if (!stage || sections.length < 2 || isDesignMode()) return;

    sections.forEach(function (section) {
      var slot = slotFor(section) || section.querySelector('[data-acordeon-slot]');
      if (slot && slot.parentNode !== stage) {
        stage.appendChild(slot);
      }
      if (section !== host) {
        var wrap = section.closest('.shopify-section');
        if (wrap) wrap.hidden = true;
      }
    });
  }

  function updateChrome(current) {
    var sections = allSections();
    var host = sections[0];
    var entries = navEntries();
    if (!host || !current) return;

    var iconSource = host.querySelector('[data-acordeon-nav-icon]');
    fillNav(host.querySelector('[data-acordeon-nav]'), entries, current, iconSource, false);
    fillNav(host.querySelector('[data-acordeon-mobile-nav]'), entries, current, iconSource, true);

    var mobileLabel = host.querySelector('[data-acordeon-menu-label]');
    var title = current.getAttribute('data-acordeon-title') || '';
    if (mobileLabel) mobileLabel.textContent = title;

    var mobile = host.querySelector('.acordeon__mobile');
    if (mobile) mobile.hidden = entries.length < 2;
  }

  function showInstance(target) {
    var sections = allSections();
    if (!target) target = sections[0];
    if (!target) return;

    var previous = currentSection();
    var changed = previous !== target;

    sections.forEach(function (section) {
      var slot = slotFor(section);
      var isCurrent = section === target;
      section.classList.toggle('is-current', isCurrent);
      if (slot) slot.hidden = !isCurrent;
    });

    if (changed) closeMenus();
    updateChrome(target);

    if (target.id && history.replaceState) {
      history.replaceState(null, '', '#' + target.id);
    }
  }

  function instanceFromHash() {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return null;
    return document.getElementById(hash);
  }

  function bindGroup() {
    var sections = allSections();
    var host = sections[0];
    if (!host) return;

    sections.forEach(function (section, index) {
      section.classList.toggle('is-nav-host', index === 0);
    });

    collectSlots();

    if (!window.__acordeonInitialized) {
      window.__acordeonInitialized = true;
      var initial = instanceFromHash();
      if (!initial || sections.indexOf(initial) === -1) initial = host;
      showInstance(initial);
      return;
    }

    updateChrome(currentSection() || host);
  }

  function toggleMenu(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = !toggle.classList.contains('is-open');
    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    setDisclosure(panel, open);
  }

  function toggleItem(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = !toggle.classList.contains('is-open');
    var slot = toggle.closest('[data-acordeon-slot]');
    var others = slot
      ? Array.prototype.slice.call(slot.querySelectorAll('[data-acordeon-item-toggle]'))
      : [];

    others.forEach(function (other) {
      if (other === toggle) return;
      other.classList.remove('is-open');
      other.setAttribute('aria-expanded', 'false');
      setDisclosure(document.getElementById(other.getAttribute('aria-controls')), false);
    });

    toggle.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    setDisclosure(panel, open);
  }

  function bindDelegation() {
    if (window.__acordeonDelegated) return;
    window.__acordeonDelegated = true;

    document.addEventListener('click', function (event) {
      var menuToggle = event.target.closest('[data-acordeon-menu-toggle]');
      if (menuToggle) {
        toggleMenu(menuToggle);
        return;
      }

      var itemToggle = event.target.closest('[data-acordeon-item-toggle]');
      if (itemToggle) {
        toggleItem(itemToggle);
      }
    });
  }

  class AcordeonList extends HTMLElement {
    connectedCallback() {
      bindDelegation();
      bindGroup();
    }
  }

  if (!customElements.get('acordeon-list')) {
    customElements.define('acordeon-list', AcordeonList);
  }
})();
